// extracted by mini-css-extract-plugin
module.exports = {"webcam":"sXz5OpZH5Xa5lfTH1KVn_","webcamImage":"loqTWtdb_GOTnDXSqA0R8","webcamContainer":"_5HPUQyIcUP6tsYRFZ8DGN","loading":"jKD7CjOaz7yvgZGBeYC9_","load":"E2M5fONpWtSJhDOPWOaDB"};